///
/// EarthBrowser
///
/// Created by Matt Giger on 11/16/2025
/// Copyright (c) 2025 Geodata Labs
///

import { type Geometry } from "@stovokor/shader/Geometry"
import { NodeBase } from "@stovokor/engine/NodeBase"
import { SimpleRenderer, type DrawState } from "@stovokor/engine/Renderer"
import { type Material } from "@stovokor/shader/Material"
import { white, type color } from "@stovokor/math/color"
import { type StovokorContext } from "@stovokor/StovokorContext"

export class SimpleNode extends NodeBase implements Material {
	public available = true
	public color: color

	/**
	 * @param drawState - fixed-function overrides, e.g. a polygonOffset for
	 *                    fills draped on the terrain (see surfaceDepthBias)
	 */
	constructor(context: StovokorContext, geometry: Geometry, color: color = white, drawState?: DrawState) {
		super()
		this.color = color
		this.renderer = new SimpleRenderer(context, geometry, this, drawState)
	}

	public get transparency(): boolean {
		return this.color.a < 1
	}
}
